<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">
                    <header>
                        <figure><i class="icon icon-icon_files"></i></figure>
                        <div>
                            <span class="breadcrumb">
                                Template <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>

                    <main>

                         <languages :translations="resource.translations" :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                                <form-scopes label='Scopes' v-model="resource"></form-scopes>

                                <form-file label='Image' v-model="resource.picture_id" width="200"></form-file>

                                <form-publication-state label="Etat" v-model="resource.publication_state_id"></form-publication-state>

                                <form-text label="Name" v-model="resource.name"></form-text>

                                <form-gallery label="Images" v-model="resource.medias" width="200"></form-gallery>

                                <form-editor label="Template" v-model="resource.template" language="html" :required="true"></form-editor>

                            </tab>
                        </tabs>

                    </main>
                    <footer>
                    </footer>
                </article>
            </div>
        </div>
    </transition>
</template>
<script>

    import {Api} from '../../../Api.js'
    import TemplateService from './TemplateService.js';
    import Edit from '../../../layouts/Edit.vue';

    import ComponentConditions from "../../../components/Conditions.vue";

    export default {
        extends: Edit,
        components: {
            'component-conditions': ComponentConditions
        },
        data () {
            return {
            }
        },
        mounted: function(){

        },
        methods:{
            resourceLoaded: function(){
                this.initialize()
            },
            beforeUpdate: function(Resource){
                return true;
            },
            getResource: function(){
                return TemplateService
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/campaign/template/Edit.vue